import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/distribucionCajas';
import Distribucion from './DistribucionList';

const ms2p = (state) => {
  return {
    ...state.distribucion_cajas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Distribucion);
